import { Box, makeStyles } from '@material-ui/core';
import React, { useEffect } from 'react';

import { api } from '../../../../../core/api';
import { useCompaniesDispatch } from '../../../shared/CompanyContext/CompanyContext';
import { CompanyContextActionTypes } from '../../../shared/CompanyContext/CompanyContext.types';
import CompanyTabContent from '../shared/CompanyTabContent';
import { useCompanyTabLoader } from '../shared/useCompanyTabLoader';
import ActivityCompany from './ActivityCompany';
import GeneralInformation from './GeneralInfo';

const CompanyInfo: React.FC = () => {
  const { data, isLoading } = useCompanyTabLoader(api.company.getGeneralData);
  const dispatchCompany = useCompaniesDispatch();
  const classes = useStyles();

  useEffect(() => {
    if (data) {
      dispatchCompany({
        type: CompanyContextActionTypes.SetCompanyGeneralInfo,
        payload: data,
      });
    }
  }, [data, dispatchCompany]);

  return (
    <CompanyTabContent isLoading={isLoading}>
      <Box className={classes.dataContainer}>
        <GeneralInformation data={data} />
        <ActivityCompany data={data?.companyActivity} />
      </Box>
    </CompanyTabContent>
  );
};

const useStyles = makeStyles(() => ({
  dataContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
}));

export default CompanyInfo;
